export default "__VITE_ASSET__DEzpCpDe__"